<template>
  <main id="accueil_aap" role="main" class="overflow-hidden">

    <div class="position-relative bg-primary overflow-hidden space-top-1">
      <div class="container position-relative z-index-2 space-top-1 space-top-md-1 space-bottom-1 space-bottom-md-1">
        <div class="w-md-80 w-xl-60 text-center mx-md-auto">
          <div class="mb-7">
            <h1 class="display-4 text-white mb-4">Appels à projet</h1>
          </div>
        </div>
      </div>
      <figure class="position-absolute right-0 bottom-0 left-0 mb-n1">
        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
          <path fill="#F9F9F9" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z">
          </path>
        </svg>
      </figure>
    </div>

    <div class="position-relative z-index-2">
      <!-- Content -->
      <div class="d-md-flex">
        <div class="container d-md-flex align-items-md-center text-center ">
          <div class="w-lg-85 mx-lg-auto">

            <!-- Info -->
            <div class="mb-6">

              <p class="lead">Trouver ou poster un appel à projet</p>

            </div>
            <!-- End Info -->


            <div class="cbp"
                 data-hs-cbp-options='{
            "animationType": "fadeOut",
            "caption": "zoom",
            "gapHorizontal": 40,
            "gapVertical": 40
          }'>

              <!-- Item -->
              <div class="cbp-item">
                <a class="cbp-caption bg-white rounded" href="{$link->getModuleLink('dlnkaap', 'poster_un_appel')|escape:'html'}">
                  <div class="overflow-hidden rounded-lg">
                    <div class="cbp-caption-defaultWrap">
                      <img class="rounded-lg" src="/modules/dlnkaap/img/projet (9).jpg" alt="Image Description">
                    </div>
                  </div>
                  <div class="p-4 bg-img-hero rounded-lg text-white">
                    <span class="d-block text-body font-weight-bold text-cap">Proposer</span>
                    <span class="d-block h3 mb-0">des appels à projet</span>
                  </div>
                </a>
              </div>
              <!-- End Item -->


              <!-- Item -->
              <div class="cbp-item">
                <a class="cbp-caption bg-white rounded" href="{$link->getModuleLink('dlnkaap', 'formulaire_pageVitrine')|escape:'html'}">
                  <div class="overflow-hidden rounded-lg">
                    <div class="cbp-caption-defaultWrap">
                      <img class="rounded-lg" src="/modules/dlnkaap/img/partenaires (19).jpg" alt="Image Description">
                    </div>
                  </div>
                  <div class="p-4 bg-img-hero rounded-lg text-white">
                    <span class="d-block text-body font-weight-bold text-cap">Partager</span>
                    <span class="d-block h3 mb-0">des projets</span>
                  </div>
                </a>
              </div>
              <!-- End Item -->


              <!-- Item -->
              <div class="cbp-item">
                <a class="cbp-caption bg-white rounded" href="{$link->getModuleLink('dlnkaap', 'crowdfunding_list')|escape:'html'}">
                  <div class="overflow-hidden rounded-lg">
                    <div class="cbp-caption-defaultWrap">
                      <img class="rounded-lg" src="/modules/dlnkaap/img/projet (10).jpg" alt="Image Description">
                    </div>
                  </div>
                  <div class="p-4 bg-img-hero rounded-lg text-white">
                    <span class="d-block text-body font-weight-bold text-cap">Participer</span>
                    <span class="d-block h3 mb-0">à des projets en cours</span>
                  </div>
                </a>
              </div>
              <!-- End Item -->


              <!-- Item -->
              <div class="cbp-item">
                <a class="cbp-caption bg-white rounded" href="#">
                  <div class="overflow-hidden rounded-lg">
                    <div class="cbp-caption-defaultWrap">
                      <img class="rounded-lg" src="/modules/dlnkaap/img/projet (14).jpg" alt="Image Description">
                    </div>
                  </div>
                  <div class="p-4 bg-img-hero rounded-lg text-white">
                    <span class="d-block small font-weight-bold text-cap text-body">Connaître</span>
                    <span class="d-block h4 mb-0">de nouveaux partenaires</span>
                    <span class="d-block small font-weight-bold text-cap text-body">Solliciter</span>
                    <span class="d-block h4 mb-0">des ressources</span>
                  </div>
                </a>
              </div>
              <!-- End Item -->

              <!-- Item -->
              <div class="cbp-item">
                <a class="cbp-caption bg-white rounded" href="#">
                  <div class="overflow-hidden rounded-lg">
                    <div class="cbp-caption-defaultWrap">
                      <img class="rounded-lg" src="/modules/dlnkaap/img/projet (4).jpg" alt="Image Description">
                    </div>
                  </div>
                  <div class="p-4 bg-img-hero rounded-lg text-white">
                    <span class="d-block small text-white font-weight-bold text-cap text-body">Trouver</span>
                    <span class="d-block h4 mb-0">des financements</span>
                    <span class="d-block small text-white font-weight-bold text-cap text-body">Découvrir</span>
                    <span class="d-block h4 mb-0">les projets autour de moi</span>

                  </div>
                </a>
              </div>
              <!-- End Item -->



              <!-- Item -->
              <div class="cbp-item">
                <a class="cbp-caption bg-white rounded" href="#">
                  <div class="overflow-hidden rounded-lg">
                    <div class="cbp-caption-defaultWrap">
                      <img class="rounded-lg" src="/modules/dlnkaap/img/projet (11).jpg" alt="Image Description">
                    </div>
                  </div>
                  <div class="p-4 bg-img-hero rounded-lg text-white">
                    <span class="d-block small text-white font-weight-bold text-cap text-body">Echanger</span>
                    <span class="d-block h4 mb-0">avec ma communauté</span>
                    <span class="d-block small text-white font-weight-bold text-cap text-body">Partager</span>
                    <span class="d-block h4 mb-0">mes actions</span>
                  </div>
                </a>
              </div>
              <!-- End Item -->


            </div>
            <!-- End Form -->
          </div>
        </div>
      </div>
      <!-- End Content -->

      <!-- Hero Section -->
      <div class="position-relative">
        <div class="bg-img-hero" style="background-image: url(/themes/template/img/components/abstract-shapes-12.svg);">
          <div class="container space-2 position-relative z-index-2">

            <h2>Les dernières candidatures :</h2>

            <!-- Blogs Section -->
            <div class="container space-2 space-lg-3">
              <div class="row justify-content-lg-between">
                <div class="col-lg-8">

                  <article v-for="aap in aaps" class="row mb-7">
                    <div class="col-md-5">
<!--                      <img class="card-img" src="/themes/template/img/400x500/img7.jpg">-->
                      <img v-if="aap.projet_illustration" class="card-img" :src="aap.projet_illustration"
                           :alt="'Visuel du projet : ' + aap.projet_nom">
                      <img v-else class="card-img" :src="pseudoRandomImage(aap.id)" :alt="'Visuel du projet : ' + aap.projet_nom">
                    </div>
                    <div class="col-md-7">
                      <div class="card-body d-flex flex-column h-100 px-0 pt-2">
                        <span class="d-block mb-2 pb-2 border-bottom border-primary border-1">
                          <span class="font-weight-bold" v-for="(tag,index) in aap.tags">
                            {{ tag.nom }}<span v-if="index != aap.tags.length - 1"> / </span>
                          </span>
                        </span>
                        <h3 class="text-primary" href="blog-single-article.html">{{aap.projet_nom}}</h3>
                        <p>{{ aap.activite_principale|truncate(200) }}</p>
                        <div class="d-flex flex-wrap align-items-center mt-auto">
                          <h5 class="col-12 pl-0">Recherches :</h5>
                          <div class="col-12 pl-0">
                            <span class="badge badge-primary" data-tooltip="tooltip" title="Recherche bénévoles" v-if="aap.benevoles"
                              style="z-index: 10; position: relative">
                              <i class="fa fa-users fa-2x" aria-hidden="true"></i>
                            </span>
                              <span class="badge badge-primary" data-tooltip="tooltip" title="Besoins matériel" v-if="aap.besoins_materiels"
                                    style="z-index: 10; position: relative">
                              <i class="fa fa-wrench fa-2x" aria-hidden="true"></i>
                            </span>
                              <span class="badge badge-primary" data-tooltip="tooltip" title="Recherche locaux" v-if="aap.besoins_locaux"
                                    style="z-index: 10; position: relative">
                              <i class="fa fa-building fa-2x" aria-hidden="true"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>


                  <!-- Sticky Block End Point -->
                  <div id="stickyBlockEndPoint"></div>
                </div>

                <div class="col-lg-3">
                  <div class="mb-7">
                    <div class="mb-3">
                      <h3>Newsletter</h3>
                    </div>

                    <!-- Form -->
                    <form class="js-validate mb-2">
                      <label class="sr-only" for="subscribeSr">Subscribe</label>
                      <div class="input-group input-group-flush mb-3">
                        <input type="email" class="form-control form-control-sm" name="email" id="subscribeSr" placeholder="Votre email" aria-label="Votre email" required
                               data-msg="Please enter a valid email address.">
                      </div>
                      <button type="submit" class="btn btn-sm btn-primary btn-block">M'abonner</button>
                    </form>
                    <!-- End Form -->

                    <p class="small">Etre informé(e) des actualités concernant les appels à projet.</p>
                  </div>

                  <div class="mb-7">
                    <div class="mb-3">
                      <h3>Activités</h3>
                    </div>

                    <!-- Blog -->
                    <article class="mb-3">
                      <a class="card card-frame p-3" href="#">
                        <div class="media align-items-center">
                          <div class="media-body mr-2">
                            <h4 class="h6 mb-0">Apprenez les bons réflexes eco-responsables</h4>
                            <span class="d-block font-size-1 text-body">Fév 08, 2023</span>
                          </div>
                          <i class="fas fa-angle-right"></i>
                        </div>
                      </a>
                    </article>
                    <!-- End Blog -->

                    <!-- Blog -->
                    <article class="mb-3">
                      <a class="card card-frame p-3" href="#">
                        <div class="media align-items-center">
                          <div class="media-body mr-2">
                            <h4 class="h6 mb-0">Spectacle des petits chanteurs</h4>
                            <span class="d-block font-size-1 text-body">Fév 09, 2023</span>
                          </div>
                          <i class="fas fa-angle-right"></i>
                        </div>
                      </a>
                    </article>
                    <!-- End Blog -->

                    <!-- Blog -->
                    <article class="mb-3">
                      <a class="card card-frame p-3" href="#">
                        <div class="media align-items-center">
                          <div class="media-body mr-2">
                            <h4 class="h6 mb-0">Récolte d'accessoires informatiques pour les ukrainiens</h4>
                            <span class="d-block font-size-1 text-body">Fév 10, 2023</span>
                          </div>
                          <i class="fas fa-angle-right"></i>
                        </div>
                      </a>
                    </article>
                    <!-- End Blog -->
                  </div>

                  <!-- Sticky Block Start Point -->
                  <div id="stickyBlockStartPoint"></div>
                  <div class="mb-7">
                    <div class="mb-3">
                      <h3>Thématiques</h3>
                    </div>

                    <a class="btn btn-xs btn-soft-secondary mb-1" href="#">Emploi / Formation / Insertion</a>
                    <a class="btn btn-xs btn-soft-secondary mb-1" href="#">Intergénérationnel</a>
                    <a class="btn btn-xs btn-soft-secondary mb-1" href="#">Parentalité</a>
                    <a class="btn btn-xs btn-soft-secondary mb-1" href="#">Vieillissement</a>
                    <a class="btn btn-xs btn-soft-secondary mb-1" href="#">Handicap</a>
                    <a class="btn btn-xs btn-soft-secondary mb-1" href="#">Santé</a>
                    <a class="btn btn-xs btn-soft-secondary mb-1" href="#">Sport</a>
                    <a class="btn btn-xs btn-soft-secondary mb-1" href="#">Prévention</a>
                    <a class="btn btn-xs btn-soft-secondary mb-1" href="#">Développement territorial</a>
                    <a class="btn btn-xs btn-soft-secondary mb-1" href="#">Mobilité</a>
                    <a class="btn btn-xs btn-soft-secondary mb-1" href="#">Loisirs</a>
                    <a class="btn btn-xs btn-soft-secondary mb-1" href="#">Culture</a>
                    <a class="btn btn-xs btn-soft-secondary mb-1" href="#">Inclusion numérique</a>
                    <a class="btn btn-xs btn-soft-secondary mb-1" href="#">Logement</a>


                  </div>
                </div>
              </div>
            </div>
            <!-- End Blogs Section -->

          </div>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
export default {
  name: "DlnkAapActualites",
  data: function () {
    return {
      message: "",
      message_type: "",

      customer: Object,
      aaps: Array,
      tags: Array,

      page: 1,
      page_count: Number,
      status_filter: [2,3,4,5,9],
      show_deleted: false,

      checked_thematiques: [],
      checked_participation: [],
      checked_axe: [],
      checked_besoins: [],
      expanded: false,
      currentSelect: "",

      // Filtre et recherche
      start_date: Date,
    }
  },

  mounted() {
    this.start_date = 'all'
    this.get_data()
  },

  filters: {
    truncate: function (data, num) {
      const reqdString =
          data.split("").slice(0, num).join("");
      return reqdString;
    }
  },

  computed: {

  },

  watch: {

    checked_thematiques: function (new_val, old_val) {
      this.get_data()
    },

    checked_axe: function (new_val, old_val) {
      this.get_data()
    },

    page: function (new_val, old_val) {

      if (new_val < 1) {
        this.page = 1
      }

      if (new_val > this.page_count) {
        this.page = this.page_count
      }

      this.get_data()
    },

  },

  methods: {

    set_page: function (page) {
      page = parseInt(page)
      this.page = page
    },

    next_page: function () {
      this.page++
    },

    prev_page: function () {
      this.page--
    },

    close_message: function () {
      this.message = null;
    },

    get_data: function () {
      this.get_aaps()
      this.get_tags()
    },

    get_tags: async function () {
      let _this = this
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aap_tags.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.tags = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_aaps: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      api_url += '&page=' + _this.page
      api_url += '&status=' + _this.status_filter

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.aaps = response.data.aaps
            _this.page = response.data.meta.page
            _this.page_count = response.data.meta.pages
            _this.aaps_count = response.data.meta.count
            _this.wait_data = false
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_statuses: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/statuses.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.statuses = response.data.statuses
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },
  }
}
</script>

<style scoped>

</style>